<ion-buttons>

    <ion-button fill="clear" (click)="close()">
        <ion-icon size="large" color="light" slot="icon-only" name="close-circle"></ion-icon>
    </ion-button>

</ion-buttons>

<ion-content>
    <div class="header-container">
        <img src="../../assets/imgs/estudaqui-white.png" height="50" />

    </div>
    <ion-card>
        <ion-card-header>
            <div style="display: flex; align-items: center; justify-content: center;">
                        <h2> <strong>20% OFF</strong> </h2>
            
            </div>

            <h2>Garanta o <strong> preço de 2024</strong> na assinatura do <strong> Estudaqui Premium</strong>
            </h2>
        </ion-card-header>

        <ion-card-content>

            <h3 style="color:white">
                Promoção: R$ 79.90
            </h3>
            <h3>
                Normalmente: R$ 99.90/ano
            </h3>
            <br />
            <p style="color:rgb(196, 196, 196)">

                Renovação: R$ 79,90/ano.
                <br />
            </p>
        </ion-card-content>
    </ion-card>

    <div
        style="display: flex; flex-direction: column; align-items: center;  width: 100%; justify-content: center; text-align: center;">
        <h4> Esta oferta acaba em: </h4>
        <app-countdown></app-countdown>
    </div>
</ion-content>

<ion-footer class="ion-no-border ion-no-margin ion-padding-vertical ion-padding-horizontal">
    <ion-button strong mode="ios" color="orange" size="large" expand="block" (click)="handleOpenCheckout()">
        <ion-label style="color:black; font-weight: 500;">
            Continuar por R$ 79,90 no total
        </ion-label>
    </ion-button>
</ion-footer>